module.exports = __webpack_public_path__ + "img/about_swiper2.93e0e275.png";